import { useEffect, useState } from "react";

// Une tablette (même la plus large, iPad Pro 12.9" en paysage ≈ 1366px) ne doit JAMAIS basculer
// en mise en page "ordinateur" (barre latérale, colonnes larges pensées pour souris/clavier) —
// seule sa largeur dépassait le seuil (768px) et déclenchait ce mode à tort, une mauvaise
// expérience sur un écran tactile tenu en main. On distingue donc un vrai ordinateur (pointeur
// fin : souris/trackpad) d'un écran tactile (pointeur grossier : doigt) via `pointer: coarse`,
// et on ne force le mode mobile par la seule largeur que jusqu'à TABLET_MAX_WIDTH pour un
// écran tactile — une fenêtre d'ordinateur simplement réduite (pointeur fin) continue de
// basculer au seuil MOBILE_MAX_WIDTH habituel, comme avant.
const MOBILE_MAX_WIDTH = 768;
const TABLET_MAX_WIDTH = 1400;

const computeIsMobile = () => {
  if (typeof window === "undefined") return false;
  const isCoarsePointer = window.matchMedia?.("(pointer: coarse)").matches ?? false;
  if (isCoarsePointer && window.innerWidth < TABLET_MAX_WIDTH) return true;
  return window.innerWidth < MOBILE_MAX_WIDTH;
};

export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(computeIsMobile);
  useEffect(() => {
    const onResize = () => setIsMobile(computeIsMobile());
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);
  return isMobile;
}
